import React, { Children, useMemo, useState } from 'react'
import * as st from '~/assets/styl/Tabs.module.styl'
import cn from 'classnames'

interface Props {
  items: Array<string>
  children: React.ReactNode
  className?: string
}

export default function Tabs({ items, children, className }: Props) {
  const [page, setPage] = useState(0)

  const childNodes = useMemo(() => Children.toArray(children), [children])

  return (
    <div>
      {childNodes.filter(Boolean).length > 1 && (
        <ul className={cn(st.selector, className)}>
          {items
            .filter((_, i) => childNodes[i])
            .map((item, index) => (
              <li
                onClick={() => setPage(index)}
                className={cn({ [st.active]: index === page })}
                key={index}
              >
                {item}
              </li>
            ))}
        </ul>
      )}
      <div className={st.content}>
        {childNodes
          .filter(Boolean)
          .map(
            (
              child: React.DetailedReactHTMLElement<
                React.HTMLAttributes<HTMLElement>,
                HTMLElement
              >,
              index
            ) =>
              React.cloneElement(child, {
                className: cn(
                  child.props.className,
                  index === page && st.active
                ),
              })
          )}
      </div>
    </div>
  )
}
